import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users } from "lucide-react";
import { useI18n } from "@/hooks/useI18n";
import { formatBytes } from "@/lib/admin/utils/format-bytes";
import type { AdminStatsResponse } from "@/lib/admin/hooks/useEdgeFunctionStats";

interface DatabaseCardProps {
  db: AdminStatsResponse["db"];
}

export function DatabaseCard({ db }: DatabaseCardProps) {
  const { t } = useI18n();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center gap-3 pb-3">
        <div className="flex items-center justify-center h-9 w-9 rounded-lg bg-emerald-50 text-emerald-600 flex-shrink-0">
          <Users className="h-5 w-5" />
        </div>
        <CardTitle className="text-base font-semibold">
          {t("adminDashboard.database.title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="divide-y divide-gray-100">
          <div className="flex items-center justify-between py-2">
            <dt className="text-sm text-gray-600">{t("adminDashboard.database.dbSize")}</dt>
            <dd className="text-sm font-semibold text-gray-900">{formatBytes(db.size_bytes)}</dd>
          </div>
          <div className="flex items-center justify-between py-2">
            <dt className="text-sm text-gray-600">{t("adminDashboard.database.totalUsers")}</dt>
            <dd className="text-sm font-semibold text-gray-900">{db.total_users.toLocaleString()}</dd>
          </div>
          <div className="flex items-center justify-between py-2">
            <dt className="text-sm text-gray-600">{t("adminDashboard.database.mau30d")}</dt>
            <dd className="text-sm font-semibold text-gray-900">{db.mau_30d.toLocaleString()}</dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
}

export default DatabaseCard;
